<template lang="pug">
#address-type.right-panel.md-elevation-1
  .md-layout
    .md-layout-item
      md-button.md-accent.md-dense(v-bind:to="{ name: 'AddressTypes', query: $route.query }") Отмена
    .md-layout-item.md-layout.md-alignment-top-right
      md-button.md-primary.md-dense(@click="saveAddressType") Сохранить
  md-field(v-bind:class="{ 'md-invalid': errors.has('name') }")
    label Название*
    md-input(v-model="addressType.name" name="name" v-validate="'required'")
    span.md-error(v-show="errors.has('name')") {{ errors.first('name') }}
  md-field(v-bind:class="{ 'md-invalid': errors.has('description') }")
    label Описание
    md-textarea(v-model="addressType.description" name="description")
    span.md-error(v-show="errors.has('description')") {{ errors.first('description') }}
</template>

<script>
import Autocomplete from '@/components/autocomplete'
export default {
  components: {
    Autocomplete
  },
  computed: {
    addressType() {
      return this.$store.state.address.address_type
    }
  },
  created() {
    this.$store.commit('setTitle', 'Типы адресов')
    this.getAddressType()
    this.$store.dispatch('customers/getCustomerGroups')
    this.$validator.localize('ru', {
      attributes: {
        name: 'название',
        discount_type: 'тип',
        period: 'длительность',
        discount_value: 'значение',
      }
    })
  },
  methods: {
    //получение скидки
    getAddressType() {
      this.$store.commit('openRightPanel')
      if (this.$route.params.type_id == 'new') {
        this.$store.state.address.address_type = {}
      } else {
        this.$store.dispatch('address/getAddressType', { id: this.$route.params.type_id })
      }
    },
    //сохранение скидки
    saveAddressType() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.$store.dispatch(typeof this.addressType.id == 'undefined' ? 'address/addAddressType' : 'address/updateAddressType', { type: this.addressType }).then(() => {
            this.$root.$emit('reload-table', 'address-types')
          })
          this.$router.push({ name: 'AddressTypes', query: this.$route.query })
        }
      })
    }
  },
  watch: {
    '$route.params.type_id'() {
      this.getAddressType()
    }
  }
}
</script>


// WEBPACK FOOTER //
// AddressType.vue?48084362